import React from 'react';
import styled from '@emotion/styled';
import DetailMain from '../../components/organisms/lineupDetail/detailMain';
import ProductTitle from '../../components/atoms/lineupDetail/propductTitle';
import StimulationLevel from '../../components/atoms/stimulationLevel';
import LabelGroup from '../../components/molecules/labelGroup';
import CategoryGroup from '../../components/molecules/lineupDetail/categoryGroup';
import DetailMainHead from '../../components/molecules/lineupDetail/detailMainHead';
import DetailMainBody from '../../components/molecules/lineupDetail/detailMainBody';
import Br from '../../components/atoms/br';
import DetailTexts from '../../components/molecules/lineupDetail/detailTexts';
import data from '../../assets/data/products.json';
import BtnBlank from '../../components/atoms/btnBlank';
import DetailBtns from '../../components/molecules/lineupDetail/detailBtns';
import DetailBanners from '../../components/molecules/lineupDetail/detailBanners';
import Banner from '../../components/atoms/banner';
import DetailFeature from '../../components/organisms/lineupDetail/detailFeature';
import ContentWidth from '../../components/organisms/contentWidth';
import DetailFeatureBox from '../../components/molecules/lineupDetail/detailFeatureBox';
import BottomBtns from '../../components/molecules/lineupDetail/bottomBtns';
import SectionLineup from '../../components/organisms/sectionLineup';
import StoreBtnGroup from '../../components/molecules/storeBtnGroup';
import StoreBtn from '../../components/atoms/storeBtn';
import DetailFeatureItem from '../../components/molecules/lineupDetail/detailFeatureItem';
import Caption from '../../components/atoms/caption';
import { Helmet } from 'react-helmet';

const filteredData = data.filter((item, index) => {
  if (item.name === '自動で出てくるモンダミン プレミアムケアセット')
    return true;
});

const isNoStoreBtns =
  filteredData[0].amazonUrl === '' &&
  filteredData[0].lohacoUrl === '' &&
  filteredData[0].rakutenUrl === '';

const Container = styled.div``;
const MondahminDispenser = () => {
  return (
    <Container>
      <Helmet
        title="自動で出てくるモンダミン プレミアムケアセット | ラインナップ | モンダミン | アース製薬"
        meta={[
          {
            name: 'description',
            content:
              'かざすだけで簡単！計量不要でボトルがベタつかず衛生的。自動で出てくるモンダミンとモンダミンプレミアムケア 860mLボトルのセットについてご紹介します。',
          },
          {
            name: 'keywords',
            content:
              '自動で出てくるモンダミン,プレミアムケア,洗口液,マウスウォッシュ,口臭,口臭ケア,オーラルケア,アース製薬',
          },
        ]}
      />
      <ContentWidth>
        <DetailMain
          imgPath={'lineup/mondahmin-premium-dispenser-860/img-main.png'}
        >
          <DetailMainHead>
            <ProductTitle>{filteredData[0].name}</ProductTitle>
            <LabelGroup labels={filteredData[0].label}></LabelGroup>
            <StimulationLevel level={'3.5'}></StimulationLevel>
            <CategoryGroup
              categories={[
                <>
                  口臭・汚れ
                  <Br />
                  ネバつき予防
                </>,
                <>歯肉炎予防</>,
                'むし歯予防',
                'マルチケア',
                '殺菌',
                <>
                  アルコール
                  <Br onlyPc />
                  配合
                </>,
              ]}
            ></CategoryGroup>
            <DetailTexts title={filteredData[0].description}>
              コップをかざすだけで1回分が自動で出てくる簡単・便利な自動ディスペンサーです。モンダミンプレミアムケアの860mL専用ボトルとのセットで、洗面台にもすっきり置けます。
            </DetailTexts>
          </DetailMainHead>
          <DetailMainBody>
            <dl>
              <dt>効果・効能：</dt>
              <dd>
                むし歯予防 / 歯肉炎予防 / 出血予防 / 歯垢付着予防 / 口臭予防 /
                口中浄化 / 口中爽快
              </dd>
            </dl>
            <dl>
              <dt>サイズ：</dt>
              <dd>860mL</dd>
            </dl>
          </DetailMainBody>
          <DetailBtns isNoStoreBtns={isNoStoreBtns}>
            {!isNoStoreBtns && (
              <StoreBtnGroup>
                <StoreBtn
                  store={'amazon'}
                  href={filteredData[0].amazonUrl}
                ></StoreBtn>
                <StoreBtn
                  store={'rakuten'}
                  href={filteredData[0].rakutenUrl}
                ></StoreBtn>
                <StoreBtn
                  store={'lohaco'}
                  href={filteredData[0].lohacoUrl}
                ></StoreBtn>
              </StoreBtnGroup>
            )}
            <BtnBlank href={filteredData[0].productInfo}>
              製品情報サイトへ
            </BtnBlank>
          </DetailBtns>
          <DetailBanners>
            <Banner
              to={'/premiumcare'}
              img={'img-banner-all-in-one'}
              alt={'プレミアム'}
            ></Banner>
          </DetailBanners>
        </DetailMain>
        <DetailFeature>
          <DetailFeatureItem>
            <DetailFeatureBox
              title={'コップをかざすだけ！自動で出てくるモンダミン'}
              img={'lineup/feature/img-feature-34.jpg'}
              alt={'コップをかざすだけで簡単！自動ディスペンサー'}
            >
              ・モンダミン1回分が自動で出てくるので、手間なく簡単に使える。
              <Br />
              ・1回分の量を10mL、20mL（10mL×2回）の2段階に調整可能。
              <Br />
              ・ボトルの液ダレやベタつきがなく、衛生的。
              <Br />
              ・モンダミンプレミアムケアの860mL専用ボトルとのセットで、洗面台にもすっきり置ける。
              <Caption>※ 単3アルカリ電池4本入り。</Caption>
            </DetailFeatureBox>
            <DetailFeatureBox
              title={'様々なモンダミンで使える'}
              img={'lineup/feature/img-feature-14.jpg'}
              alt={'様々なモンダミンで使える'}
              isImgBorder
            >
              ・モンダミン ペパーミント
              <Br />
              ・モンダミン センシティブ
              <Br />
              ・モンダミン ストロングミント
              <Br />
              ・モンダミン プレミアムケアシリーズ
              <Br />
              ・モンダミン NEXT歯周ケアシリーズ
              <Br />
              ・その他のモンダミン（モンダミンホワイトニング・NEXT歯ぐきケアシリーズを除く）
            </DetailFeatureBox>
            <DetailFeatureBox
              title={'4つのボトルサイズに対応'}
              img={'lineup/feature/img-feature-15.jpg'}
              alt={'4つのボトルサイズに対応'}
            >
              380mL、700mL、1080mL、1300mL
              <Caption>
                ※一部の限定品など、上記以外のサイズでもご使用できるものがあります。
              </Caption>
            </DetailFeatureBox>
          </DetailFeatureItem>
        </DetailFeature>
        <BottomBtns productInfo={filteredData[0].productInfo}></BottomBtns>
      </ContentWidth>
      <SectionLineup></SectionLineup>
    </Container>
  );
};
export default MondahminDispenser;
